<template>
  <transition name="product">
    <div class="scan-detail">
      <van-nav-bar @click-left="onClickLeft" title="证明文书识别" left-text="返回" left-arrow></van-nav-bar>
      <div v-if="islj" class="detailbox">
        <div class="title">项目：【{{pname}}】已在{{getMoneyTime}}进行过兑付</div>
        <div class="rowbox">
          <div class="row">
            <div class="lable">兑付人姓名：</div>
            <div>{{name}}</div>
          </div>
          <div class="row">
            <div class="lable">兑付人身份证号：</div>
            <div>{{idcard}}</div>
          </div>
          <div class="row">
            <div class="lable">兑付人单位：</div>
            <div>{{businessOrg}}</div>
          </div>
        </div>
      </div>
       <!-- <h6>项目：【{{pname}}】证明文书真实有效</h6> -->
        <!-- <div class="btn">
          <van-button type="info" v-if="!islj" @click="getProjectGetMoney">确认兑付</van-button>
          <van-button type="info" v-else :disabled="true">确认兑付</van-button>
        </div> -->
      <div v-if="!islj" class="detailbox">
        <div class="title">项目：【{{pname}}】证明文书真实有效</div>
        <div class="rowbox">
          <div class="row">
            <div class="lable">兑付人姓名：</div>
            <div>{{name}}</div>
          </div>
          <div class="row">
            <div class="lable">兑付人身份证号：</div>
            <div>{{idcard}}</div>
          </div>
          <div class="row">
            <div class="lable">兑付人单位：</div>
            <div>{{businessOrg}}</div>
          </div>
        </div>
         <div class="btn">
          <van-button type="info" v-if="!islj" @click="getProjectGetMoney">确认兑付</van-button>
          <van-button type="info" v-else :disabled="true">确认兑付</van-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      islj: false,
      code: "",
      projectId: 0,
      title: "",
      title2: "",
      pname: "",
      name: "",
      idcard: "",
      businessOrg: "",
      getMoneyTime: "",
     
    };
  },
  created() {
    let code = this.$route.params.code.split("|");
    let moneyCode = this.$route.params.code;
    this.code = moneyCode;
    this.projectId = parseInt(code[0]);
    console.log(code, 456);
    // this.getProjectGetMoney(code,moneyCode);
    this.getprojectdetail(code);
    console.log(this.islj, "sw");
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    //获取领奖详情
    getprojectdetail(code) {
      this.request({
        url: "/v1.0/Project/getDetailTitle",
        method: "GET",
        params: {
          projectId: code[0]
        }
      })
        .then(res => {
          if (res.success) {
            this.title = res.data.isGetMoney;
            this.pname = res.data.projectName;
            this.name = res.data.businessUser;
            this.idcard = res.data.businessIdCard;
            this.businessOrg = res.data.businessOrg;
            this.getMoneyTime = res.data.getMoneyTime;
            if (res.data.moneyCode) {
              if (!res.data.isGetMoney) {
                this.islj = false;
              } else {
                this.islj = true;
              }
            } else {
              this.islj = true;
            }
          }
        })
        .catch(e => {
          this.$message({ type: "warning", message: "线索未找到" });
        });
    },
    getProjectGetMoney() {
      this.request({
        url:
          "/v1.0/Project/BusinessUserProjectGetMoney?ProjectId=" +
          this.projectId +
          "&MoneyCode=" +
          this.code,
        method: "GET"
      }).then(res => {
        if (res.success) {
          console.log(res, 456);
          this.islj = false;
          this.$message({ type: "success", message: "领奖成功" });
          this.$router.back();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.scan-detail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
.btn {
  width: 100%;
  text-align: center;
}
.detailbox {
  overflow: hidden;
  background: #ffffff;
}
.row {
  display: flex;
  padding: 0 20px;
}
.lable {
  min-width: 150px;
  text-align: right;
}
.title {
  background: 	#FF1493;
  color: #ffffff;
  padding: 0 20px;
}
.rowbox{
  margin-top: 10px;
  padding-bottom:15px ;
}
</style>